import { render, staticRenderFns } from "./risenewsdetail.vue?vue&type=template&id=387bfd25&scoped=true&"
import script from "./risenewsdetail.vue?vue&type=script&lang=js&"
export * from "./risenewsdetail.vue?vue&type=script&lang=js&"
import style0 from "./risenewsdetail.vue?vue&type=style&index=0&id=387bfd25&lang=less&scoped=true&"
import style1 from "./risenewsdetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387bfd25",
  null
  
)

export default component.exports